











































































































































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter, Mutation} from 'vuex-class';
import {
  ActionTypes,
  GetterTypes,
  MutationTypes,
} from '@/modules/neovehicle/store/types';
import {
  Brand,
  Family,
  FamilySegment,
  FamilySegments,
  Segment,
  tabs,
  vehicleTypes,
} from '@/modules/neovehicle/models';
import {CountryEnum} from '@/models/Enums';
import {GET_COUNTRY_SELECTED} from '@/store/root';
import RadioGroupList from '@/modules/neovehicle/components/radio-group-list.component.vue';
import unionBy from 'lodash/unionBy';
import pick from 'lodash/pick';
import {MessageService} from '@/services/messageService';
import debounce from 'lodash/debounce';
import {FamilyExpressOptionEnum} from '@/modules/neovehicle/models/enums';

const NAME_OTHERS = 'OUTROS';
const NAME_NOT_APPLICABLE = 'NÃO APLICÁVEL';

@Component({
  components: {
    RadioGroupList,
  },
})
export default class extends Vue {
  @Getter(GetterTypes.GET_FAMILY_SEGMENT_SELECTED)
  public familySegment: FamilySegment;

  @Getter(GetterTypes.GET_BRAND_WITH_CONTRACTS)
  public brandsWithContract: Brand[];

  @Getter(GetterTypes.GET_SEGMENTS_BY_BRAND)
  public segments: Segment[];

  @Getter(GET_COUNTRY_SELECTED)
  public country: CountryEnum;

  @Getter(GetterTypes.GET_FAMILY_SEGMENTS)
  public familySegments: FamilySegments[];

  @Getter(GetterTypes.GET_FAMILIES_WITH_SEGMENTS)
  public familiesWithSegment: Family[];

  @Action(ActionTypes.FETCH_BRAND_WITH_CONTRACTS)
  public getBrandsWithContracts: (filter: {
    idVehicleTypes: number[];
    country: CountryEnum;
  }) => Promise<boolean>;

  @Action(ActionTypes.FETCH_SEGMENTS_BY_BRAND)
  public getSegmentsByBrand: (filter: {
    idBrand: number;
    idVehicleTypes: number[];
    country: CountryEnum;
  }) => Promise<boolean>;

  @Action(ActionTypes.FETCH_FAMILY_SEGMENTS)
  public getFamilySegments: (filter: {
    idFamily: number;
    idVehicleType: number;
    country: CountryEnum;
  }) => Promise<boolean>;

  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public setCurrentTab: (selected: string) => void;

  @Action(ActionTypes.SAVE_FAMILY_CLASSIFICATION)
  public saveFamiliesSegment: (family: {
    idFamily: number;
    country: number;
    segments: Array<{ id: number; idBrand: number }>;
  }) => Promise<boolean>;

  @Action(ActionTypes.SAVE_FAMILY_SEGMENT_FROM_OPTION)
  public saveFamilySegmentFromOption: (payload: {
    idFamily: number;
    country: number;
    familySegmentOption: number;
    idVehicleType: number;
    idBrands: number[];
  }) => Promise<boolean>;

  @Action(ActionTypes.FETCH_FAMILIES_WITH_SEGMENT)
  public getFamiliesWithSegment: (filter: {
    familyName: string;
    idVehicleType: number;
    country: CountryEnum;
  }) => Promise<Family[]>;

  @Action(ActionTypes.CLONE_FAMILY_SEGMENT)
  public cloneFamilySegment: (payload: {
    idFamily: number;
    country: number;
    idFamilyClone: number;
    idVehicleType: number;
    idBrands: number[];
  }) => Promise<boolean>;

  @Mutation(MutationTypes.SET_SEGMENTS_BY_BRAND)
  public setSegmentsByBrand: (payload: any[]) => void;

  @Ref('expressOptionRef')
  public readonly expressOptionRef!: { reset: () => void };

  public segmentsApplied: Segment[] = [];

  public isLoading = false;
  public familiesSegment: FamilySegment[];
  public vehicleTypes = vehicleTypes;
  public brandSelected: number;
  public tabSelected: string = '0';
  public segmentSelected: number = 0;
  public segmentsByBrandSelected: Array<{
    idBrand: number;
    idVehicleType: number;
    idSegment: number;
    segmentName: string;
  }> = [];
  public menu = false;
  public expressOption = '';
  public optionFamilySearch: string = '';
  public familyExpressOptionEnum = FamilyExpressOptionEnum;
  public isEdit = false;

  public header = [
    {text: 'Família', value: 'familyname', sortable: false},
    {text: 'Tipo de Veículo', value: 'vehicleTypes', sortable: false},
  ];

  public headerFamilySearch = [
    {text: 'Código', value: 'id', sortable: false},
    {text: 'Família', value: 'name', sortable: false},
    {text: 'Bandeira', value: 'brandname', sortable: false},
  ];

  @Watch('segments')
  public onWatchSegments(newValue: Segment[]) {
    this.segmentsApplied = newValue.filter((seg: Segment) => seg.isapplied);
  }

  public isFirstBrandSelected() {
    if (this.brandsWithContract.length) {
      const firstBrand = this.brandsWithContract[0];
      return this.brandSelected === firstBrand.id;
    }

    return true;
  }

  public isLastBrandSelected() {
    if (this.brandsWithContract.length) {
      const lastBrand = this.brandsWithContract[this.brandsWithContract.length - 1];
      return this.brandSelected === lastBrand.id;
    }

    return false;
  }

  public enableNextBrand() {
    return !this.getSegmentSelectedByBrand(this.brandSelected);
  }

  public enableSkipBrand() {
    return this.segments.some((seg: Segment) => !seg.isapplied);
  }

  public currentTabIndex() {
    const index = this.brandsWithContract
      .map((x: Brand) => x.id)
      .indexOf(this.brandSelected);
    return index === -1 ? 0 : index;
  }

  public onChangeSegment(value: number, name: string) {
    this.setSegmentsByBrandSelected(value, name, this.brandSelected);
  }

  public setSegmentsByBrandSelected(idSegment: number, segmentName: string, idBrand: number) {
    this.segmentsByBrandSelected = unionBy(
      [
        {
          idBrand,
          idVehicleType: this.familySegment.vehicletypes[0],
          idSegment,
          segmentName,
        },
      ],
      this.segmentsByBrandSelected,
      (elem) => {
        return JSON.stringify(pick(elem, ['idBrand', 'idVehicleType']));
      },
    );
  }

  public async onChangeBrandTab(value: string) {
    const brand = this.brandsWithContract.filter((b: Brand) => b.id === Number(value))[0];
    await this.onChangeBrand(brand);
  }

  public async onChangeBrand(value: Brand) {
    this.setSegmentsByBrand([]);

    this.tabSelected = String(value.id);
    this.brandSelected = value.id;

    this.isLoading = true;

    await this.loadSegmentsByBrand(value);

    const segmentSelectedByBrand = this.getSegmentSelectedByBrand(value.id);
    if (segmentSelectedByBrand) {
      this.segmentSelected = segmentSelectedByBrand.idSegment;
    }
  }

  public async loadSegmentsByBrand(brand: Brand) {
    const f = {
      idBrand: brand.id,
      country: this.country,
      idVehicleTypes: this.familySegment.vehicletypes,
    };

    await this.getSegmentsByBrand(f);

    this.isLoading = false;
  }

  public async loadFamilySegments() {
    const f = {
      idFamily: this.familySegment.idfamily,
      idVehicleType: this.familySegment.vehicletypes[0],
      country: this.country,
    };
    await this.getFamilySegments(f);

    this.familySegments.forEach((familySegments: FamilySegments) =>
      this.setSegmentsByBrandSelected(familySegments.idSegment, familySegments.segmentName, familySegments.idBrand));

    this.isLoading = false;
  }

  public invalid() {
    return this.segmentsByBrandSelected.length !== this.brandsWithContract.length;
  }

  public async onSkipBrand() {
    const notAppliedSegments = this.segments
      .filter((seg: Segment) => !seg.isapplied);

    if (notAppliedSegments.length === 1) {
      const notAppliedSegment = notAppliedSegments[0];
      this.onChangeSegment(notAppliedSegment.id, notAppliedSegment.name);
    }

    if (!this.isLastBrandSelected()) {
      await this.onNextBrand();
    }
  }

  public currentSegmentSelectedByBrand() {
    const brand = this.brandsWithContract[this.currentTabIndex()];
    return this.getSegmentSelectedByBrand(brand.id);
  }

  public async onNextBrand() {
    const brand = this.brandsWithContract[this.currentTabIndex() + 1];
    await this.onChangeBrand(brand);
  }

  public async onPreviousBrand() {
    const brand = this.brandsWithContract[this.currentTabIndex() - 1];
    await this.onChangeBrand(brand);
  }

  public getSegmentSelectedByBrand(brandValue: number) {
    const segments = this.segmentsByBrandSelected.filter(
      (x: any) => x.idBrand === brandValue,
    );
    return segments.length ? segments[0] : undefined;
  }

  public onSaveAndClose() {
    const familySegment = {
      idFamily: this.familySegment.idfamily,
      country: this.country,
      segments: this.segmentsByBrandSelected.map((x: any) => ({
        id: x.idSegment,
        idBrand: x.idBrand,
      })),
    };

    this.isLoading = true;

    this.saveFamiliesSegment(familySegment)
      .then(() => {
        this.isLoading = false;
        MessageService.Success(
          'Sucesso',
          'Operação realizada com sucesso.',
          'center',
        );
        this.returnFamiliesList();
      })
      .catch(() => {
        return MessageService.Error(
          'Erro',
          'Operação não realizada.',
          'center',
        );
      });
  }

  public returnFamiliesList() {
    this.setCurrentTab(tabs.list);
    this.$router.push('/neovehicle/family');
  }

  public onClose() {
    this.returnFamiliesList();
  }

  public async created() {
    if (!this.familySegment) {
      await this.$router.push('/neovehicle/family');
      return;
    }

    this.familiesSegment = [this.familySegment];
    this.isEdit = this.$route.params.edit === 'true';
    await this.loadBrandsWithContracts();
  }

  public async loadBrandsWithContracts() {
    this.isLoading = true;
    await this.getBrandsWithContracts({
      idVehicleTypes: this.familySegment.vehicletypes,
      country: this.country,
    });

    const firstBrand = this.brandsWithContract[0];
    this.brandSelected = firstBrand.id;
    this.tabSelected = String(this.brandSelected);

    await this.loadFamilySegments();
    await this.onChangeBrand(firstBrand);

    this.isLoading = false;
  }

  public isNotApplicable() {
    const currentSegmentSelected = this.currentSegmentSelectedByBrand();

    return currentSegmentSelected
      && currentSegmentSelected.segmentName
      && currentSegmentSelected.segmentName.toLocaleLowerCase() === NAME_NOT_APPLICABLE.toLocaleLowerCase();
  }

  public handleOptionFamilyItem(idFamilyClone: number) {
    const isConfirm = confirm(`Deseja clonar os segmentos da família ${idFamilyClone}?`);

    if (isConfirm) {
      this.cloneFamilySegment({
        idFamily: this.familySegment.idfamily,
        country: this.country,
        idFamilyClone,
        idVehicleType: this.familySegment.vehicletypes[0],
        idBrands: this.brandsWithContract.map((b: Brand) => b.id),
      })
        .then(() => {
          this.isLoading = false;
          MessageService.Success(
            'Sucesso',
            'Operação realizada com sucesso.',
            'center',
          );
          this.returnFamiliesList();
        })
        .catch(() => {
          return MessageService.Error(
            'Erro',
            'Operação não realizada.',
            'center',
          );
        });
      this.menu = false;
    }
  }

  public handleExpressOption() {
    const optionMessage: any = {
      [FamilyExpressOptionEnum.Anothers]: 'Deseja aplicar o segmento "Outros" para todas as Bandeiras?',
      [FamilyExpressOptionEnum.NotApplicable]: 'Deseja aplicar o segmento "Não Aplicável" para todas as Bandeiras?',
    };

    if (optionMessage[this.expressOption]) {
      const isConfirm = confirm(optionMessage[this.expressOption]);

      if (isConfirm) {
        this.isLoading = true;

        const payload = {
          idFamily: this.familySegment.idfamily,
          idVehicleType: this.familySegment.vehicletypes[0],
          idBrands: this.brandsWithContract.map((b: Brand) => b.id),
          country: this.country,
          familySegmentOption: Number(this.expressOption),
        };

        this.saveFamilySegmentFromOption(payload)
          .then(() => {
            this.isLoading = false;
            MessageService.Success(
              'Sucesso',
              'Operação realizada com sucesso.',
              'center',
            );
            this.returnFamiliesList();
          })
          .catch(() => {
            return MessageService.Error(
              'Erro',
              'Operação não realizada.',
              'center',
            );
          });
        this.menu = false;
      }

      this.expressOptionRef.reset();
      this.expressOption = '';
    }
  }

  public get handleOptionFamilySearch() {
    return debounce(() => {
      if (this.optionFamilySearch) {
        this.isLoading = true;
        this.getFamiliesWithSegment({
          country: this.country,
          idVehicleType: this.familySegment.vehicletypes[0],
          familyName: this.optionFamilySearch,
        }).then(() => {
          this.isLoading = false;
        }).catch((err: any) => {
          this.isLoading = false;
          throw err;
        });
      }
    }, 500);
  }
}
